import React, { useState } from'react';
import { AnimatePresence } from 'framer-motion';

import {About, Footer, Header, Skills, Work} from './container';
import { Navbar } from './components';
import './App.scss';
import { SideMenu } from './components/SideMenu/SideMenu';


const App=()=>{
  const [menuOpen, setMenuOpen] = useState(false);
  return(
   <div className='app'>
    <AnimatePresence>
    {menuOpen && <SideMenu setMenuOpen={setMenuOpen}/>}
    </AnimatePresence>
    <Navbar setMenuOpen={setMenuOpen}/>
    <Header />
    <About />
    <Work />
    <Skills />
    <Footer />
   </div>
  );
}


export default App;